(ns minorodata.app.semver
  (:refer-clojure :exclude [compare inc])
  (:require ["semver" :as semver]))

;; Refer to https://www.npmjs.com/package/semver
;; for full conumentation

(defn compare
  "Compares semantic version numbers"
  [version-1 version-2]
  (let [v1 (semver/coerce version-1)
        v2 (semver/coerce version-2)]
    (cond
     (semver/eq v1 v2) 0
     (semver/gt v1 v2) 1
     (semver/lt v1 v2) -1)))

(defn inc
  "Increments semantic versions. `patch` is a default level.
  Possible levels: major, premajor, minor, preminor, patch, prepatch, or prerelease"
  [v & {:keys [release]
        :or   {release "patch"}}]
  (semver/inc v release))
